import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EndPoints } from '../../helpers/ApiEndPoints';
import { axiosPrivate } from '../../helpers/ApiClient';
import { customFY, InitialStateMaturityAssessment } from './MaturityAssessment';

const {
  GET_ISO_QUESTIONS,
  GET_NIST_QUESTIONS,
  SAVE_MATURITY_DATA,
  GET_CIS_QUESTIONS,
  GET_CIS_SUB_SECTIONS,
  GET_CIS_QUESTIONS_DETAILS,
  GET_PCI_QUESTIONS,
  GET_REGIONS,
  GET_SECURITY_FRAMEWORKS,
  SAVE_FINANCIAL_CYCLE,
} = EndPoints;

const initialState: InitialStateMaturityAssessment = {
  isLoading: false,
  isAccordionLoading: false,
  isSaving: false,
  isoMainSectionArr: [],
  isoSubSectionArr: [],
  isoQuestionArr: [],
  nistFunctionSectionArr: [],
  nistCategorySectionArr: [],
  nistSubCategorySectionArr: [],
  nistQuestionArr: [],
  cisQuestionArr: [],
  cisSubSectionArr: [],
  cisQuestionDetailsArr: [],
  pciMainSectionArr: [],
  pciQuestionArr: [],
  pciSubSectionArr: [],
  regionsArr: [],
  securityFrameworksArr: [],
  custom_financial_year: null,
  maturityData: {
    maturityCardArr: [],
    current_year_target: 0,
    final_year_target: null,
    framework_name: '',
    overall_level: null,
    tier_level: [],
  },
  nfyData: null,
};

const getISOMainSections = createAsyncThunk<any, any>(
  'maturityAssessment/getISOMainSections',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_ISO_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getISOSubSections = createAsyncThunk<any, any>(
  'maturityAssessment/getISOSubSections',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_ISO_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getISOQuestions = createAsyncThunk<any, any>(
  'maturityAssessment/getISOQuestions',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_ISO_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getNISTFunctionSection = createAsyncThunk<any, any>(
  'maturityAssessment/getNISTFunctionSection',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_NIST_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getNISTCategorySection = createAsyncThunk<any, any>(
  'maturityAssessment/getNISTCategorySection',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_NIST_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getNISTSubCategorySection = createAsyncThunk<any, any>(
  'maturityAssessment/getNISTSubCategorySection',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_NIST_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getNISTQuestionArr = createAsyncThunk<any, any>(
  'maturityAssessment/getNISTQuestionArr',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_NIST_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getCisQuestions = createAsyncThunk<any, any>(
  'maturityAssessment/getCisQuestions',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_CIS_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getCisSubSections = createAsyncThunk<any, any>(
  'maturityAssessment/getCisSubSections',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_CIS_SUB_SECTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getCisQuestionsDetails = createAsyncThunk<any, any>(
  'maturityAssessment/getCisQuestionsDetails',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_CIS_QUESTIONS_DETAILS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getPCIMainSections = createAsyncThunk<any, any>(
  'maturityAssessment/getPCIMainSections',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_PCI_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getPCISubSections = createAsyncThunk<any, any>(
  'maturityAssessment/getPCISubSections',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_PCI_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getPCIQuestions = createAsyncThunk<any, any>(
  'maturityAssessment/getPCIQuestions',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(GET_PCI_QUESTIONS, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const saveMaturityData = createAsyncThunk<any, any>(
  'saveMaturityData',
  async (payload) => {
    try {
      const resp = await axiosPrivate.post(SAVE_MATURITY_DATA, payload);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getRegions = createAsyncThunk<any, void>(
  'maturityAssessment/getRegions',
  async () => {
    try {
      const resp = await axiosPrivate.get(GET_REGIONS);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const getSecurityFrameworks = createAsyncThunk<any, void>(
  'maturityAssessment/getSecurityFrameworks',
  async () => {
    try {
      const resp = await axiosPrivate.get(GET_SECURITY_FRAMEWORKS);
      return resp.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const saveFinancialCycle = createAsyncThunk<
  any,
  {
    region_id: number | null;
    custom_financial_year: customFY | null;
  }
>('maturityAssessment/saveFinancialCycle', async (payload) => {
  try {
    const resp = await axiosPrivate.post(SAVE_FINANCIAL_CYCLE, payload);
    return resp.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
});

export const MaturityAssessmentSlice = createSlice({
  name: 'MaturityAssessmentSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getISOMainSections.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getISOMainSections.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isoMainSectionArr = action.payload.data;
        state.maturityData.maturityCardArr = action.payload.maturity;
        state.maturityData.current_year_target =
          action.payload.current_year_target;
        state.maturityData.final_year_target = action.payload.final_year_target;
        state.maturityData.framework_name = action.payload.framework_name;
        state.maturityData.overall_level = action.payload.overall_level;
        state.maturityData.tier_level = action.payload.tier_level;
        if (action.meta.arg?.tab_type === 'nfy_plan') {
          state.nfyData = action.payload.nfyData;
        }
      })
      .addCase(getISOMainSections.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getISOSubSections.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getISOSubSections.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.isoSubSectionArr = action.payload.data;
      })
      .addCase(getISOSubSections.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getISOQuestions.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getISOQuestions.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.isoQuestionArr = action.payload.data;
      })
      .addCase(getISOQuestions.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(saveMaturityData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveMaturityData.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveMaturityData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getNISTFunctionSection.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNISTFunctionSection.fulfilled, (state, action) => {
        state.isLoading = false;
        state.nistFunctionSectionArr = action.payload.data;
        state.maturityData.maturityCardArr = action.payload.maturity;
        state.maturityData.current_year_target =
          action.payload.current_year_target;
        state.maturityData.final_year_target = action.payload.final_year_target;
        state.maturityData.framework_name = action.payload.framework_name;
        state.maturityData.overall_level = action.payload.overall_level;
        state.maturityData.tier_level = action.payload.tier_level;
        if (action.meta.arg?.tab_type === 'nfy_plan') {
          state.nfyData = action.payload.nfyData;
        }
      })
      .addCase(getNISTFunctionSection.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getNISTCategorySection.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getNISTCategorySection.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.nistCategorySectionArr = action.payload.data;
      })
      .addCase(getNISTCategorySection.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getNISTSubCategorySection.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getNISTSubCategorySection.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.nistSubCategorySectionArr = action.payload.data;
      })
      .addCase(getNISTSubCategorySection.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getNISTQuestionArr.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getNISTQuestionArr.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.nistQuestionArr = action.payload.data;
      })
      .addCase(getNISTQuestionArr.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getCisQuestions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCisQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cisQuestionArr = action.payload.data;
        state.maturityData.maturityCardArr = action.payload.maturity;
        state.maturityData.current_year_target =
          action.payload.current_year_target;
        state.maturityData.final_year_target = action.payload.final_year_target;
        state.maturityData.framework_name = action.payload.framework_name;
        state.maturityData.overall_level = action.payload.overall_level;
        state.maturityData.tier_level = action.payload.tier_level;
        if (action.meta.arg?.tab_type === 'nfy_plan') {
          state.nfyData = action.payload.nfyData;
        }
      })
      .addCase(getCisQuestions.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getCisSubSections.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getCisSubSections.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.cisSubSectionArr = action.payload.data;
      })
      .addCase(getCisSubSections.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getCisQuestionsDetails.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getCisQuestionsDetails.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.cisQuestionDetailsArr = action.payload.data;
      })
      .addCase(getCisQuestionsDetails.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getPCIMainSections.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPCIMainSections.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pciMainSectionArr = action.payload.data;
        state.maturityData.maturityCardArr = action.payload.maturity;
        state.maturityData.current_year_target =
          action.payload.current_year_target;
        state.maturityData.final_year_target = action.payload.final_year_target;
        state.maturityData.framework_name = action.payload.framework_name;
        state.maturityData.overall_level = action.payload.overall_level;
        state.maturityData.tier_level = action.payload.tier_level;
        if (action.meta.arg?.tab_type === 'nfy_plan') {
          state.nfyData = action.payload.nfyData;
        }
      })
      .addCase(getPCIMainSections.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getPCISubSections.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getPCISubSections.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.pciSubSectionArr = action.payload.data;
      })
      .addCase(getPCISubSections.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getPCIQuestions.pending, (state) => {
        state.isAccordionLoading = true;
      })
      .addCase(getPCIQuestions.fulfilled, (state, action) => {
        state.isAccordionLoading = false;
        state.pciQuestionArr = action.payload.data;
      })
      .addCase(getPCIQuestions.rejected, (state) => {
        state.isAccordionLoading = false;
      })
      .addCase(getRegions.fulfilled, (state, action) => {
        state.regionsArr = action.payload.data;
        state.custom_financial_year = action.payload.custom_financial_year;
      })
      .addCase(getSecurityFrameworks.fulfilled, (state, action) => {
        state.securityFrameworksArr = action.payload.data;
      })
      .addCase(saveFinancialCycle.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(saveFinancialCycle.fulfilled, (state, action) => {
        state.isSaving = false;
      })
      .addCase(saveFinancialCycle.rejected, (state) => {
        state.isSaving = false;
      });
  },
});

export const MaturityAssessmentActionCreator = {
  getISOMainSections,
  getISOSubSections,
  getISOQuestions,
  getNISTFunctionSection,
  getNISTCategorySection,
  getNISTSubCategorySection,
  getNISTQuestionArr,
  saveMaturityData,
  getCisQuestions,
  getCisSubSections,
  getCisQuestionsDetails,
  getPCIMainSections,
  getPCISubSections,
  getPCIQuestions,
  getRegions,
  getSecurityFrameworks,
  saveFinancialCycle,
};

export default MaturityAssessmentSlice.reducer;
